export const selectCompanies = ({ companies }) => companies.companies
export const selectCreatedCompany = ({ companies }) => companies.created
export const selectCompany = ({ companies }) => companies.current
export const selectInvoices = ({ companies }) => companies.invoices
export const selectJudicialAnswers = ({ companies }) => companies?.answers?.judicial || []
export const selectSindicatoAnswers = ({ companies }) => companies?.answers?.sindicato || []
export const selectCommentsAnswers = ({ companies }) => companies?.answers?.comments || []
export const selectJobCommentsAnswers = ({ companies }) => companies?.answers?.jobs || []
export const selectSurveyCommentsAnswers = ({ companies }) => companies?.answers?.survey || []
